import { Http } from "../Http";
export class CommondetailsAPI {

  
  public static  getcommondetails(input: any){

    var url = "api/commondetails" ;
   // alert("url"+url);
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  
  }
  public static savecommondetails(input: any) {

    var obj=JSON.stringify(input);
    var url="api/savecommondetails";
    // if(input.jobId>0 ){
    //   //var url="api/updateSchedulerJobsRepository";
    // }
   
    const resultMethod = Http.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
  
        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
}
}
